<template>
  <div>
    <ul class="m-0 p-0 soha-divide-y">
      <slot />
    </ul>
  </div>
</template>

<script>
import "@/assets/css/components/base/list.css";

export default {
  name: "List",
};
</script>
